
import { Component, Prop } from 'vue-property-decorator';
import AbstractFilterMultipleEnum from '@/components/CustomFilter/AbstractFilterMultipleEnum';
import { FilterInterface } from '@/components/CustomFilter/FilterInterface';
import { KeyInfoInterface } from '@/interfaces/KeyInfoInterface';
import { MasterDataStatusEnum, MasterDataStatusKeyInfo } from '@/items/MasterDataStatus';

@Component<MasterDataStatusFilter>({})
export default class MasterDataStatusFilter extends AbstractFilterMultipleEnum implements FilterInterface {

  // #region @Props

  @Prop({ default: 'master_data_statuses' })
  protected filterStorageKey!: string;

  @Prop({ default: 'purchase_order_filters' })
  protected filtersStorageKey!: string;

  @Prop({ default: () => MasterDataStatusEnum })
  protected enum!: Record<string, string>;

  @Prop({ default: () => MasterDataStatusKeyInfo })
  protected enumKeyInfo!: Record<string, KeyInfoInterface>;

  @Prop({ default: 'Master data status' })
  protected namePlural!: string;

  @Prop({ default: 'Zoek naar Master data status' })
  protected placeholderSearch!: string;

  @Prop({ default: false })
  protected showSearchField!: boolean;

  // #endregion
}
